
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/register",
      function () {
        return require("private-next-pages/account/register/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/register"])
      });
    }
  